import { withMotionMax } from '@hoc/withMotionMax';
import { useAutoplay } from '@hooks/useAutoplay';
import { useInView } from '@hooks/useInView';
import DotPagination from '@stories/Components/DotPagination/DotPagination';
import React, { useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';
import BannerItem from './BannerItem/BannerItem';
import S from './HomeHeroBanner.styles';
const HomeHeroBanner = ({ autoplay = 0, id, items }) => {
    const [refContainer, inView] = useInView({}, true);
    const { activeIndex, duration, paused, setActiveIndex, setPaused } = useAutoplay({
        enabled: autoplay > 0,
        duration: autoplay,
        items,
    });
    useEffect(() => {
        setPaused(!inView);
    }, [inView, setPaused]);
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => {
            setActiveIndex(Math.min(activeIndex + 1, items.length - 1));
        },
        onSwipedRight: () => {
            setActiveIndex(Math.max(activeIndex - 1, 0));
        },
    });
    return (React.createElement(S.Container, { ...swipeHandlers, ref: (r) => {
            refContainer.current = r;
            swipeHandlers.ref(r);
        }, id: id, layout: "fullWidth", "data-header-overlap": "false" },
        React.createElement(S.ItemList, null, items.map((item, index) => (React.createElement(BannerItem, { key: item.id, ...item, active: index === activeIndex, index: index, shouldPlay: inView, loopVideo: items.length == 1 })))),
        items.length > 1 && (React.createElement(S.PaginationWrapper, null,
            React.createElement(DotPagination, { autoplay: duration, count: items.length, paused: paused, value: activeIndex, onChange: (index) => {
                    setActiveIndex(index);
                    setPaused(true);
                }, customLayoutId: `HomeBanner_${id}` })))));
};
export default withMotionMax(HomeHeroBanner);
